import * as types from '../types';
import { IPaymentsApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class PaymentsHttpApi extends HttpApi implements IPaymentsApi {
  async listPayments(page = 1, limit = 20, filters: types.PaymentListFilters = {}): Promise<types.PaginatedResponse<types.Payment>> {
    const response = await this.http.get<types.PaginatedResponse<types.Payment>>(
      '/payments',
      { params: { page, limit, ...filters } }
    );
    return response.data;
  }

  async getPayment(id: string): Promise<types.Payment> {
    const response = await this.http.get<types.APIResponse<types.Payment>>(`/payments/${id}`);
    return response.data.data;
  }

  async recordPayment(data: types.RecordPaymentRequest): Promise<types.Payment> {
    const response = await this.http.post<types.APIResponse<types.PaymentCreationResult>>('/payments', data);
    return response.data.data.data;
  }

  async voidPayment(id: string, reason?: string): Promise<types.Payment> {
    const response = await this.http.post<types.APIResponse<types.Payment>>(`/payments/${id}/void`, reason ? { reason } : {});
    return response.data.data;
  }

  async getPaymentGLEntries(id: string): Promise<types.PaymentGLEntry[]> {
    const response = await this.http.get<types.APIResponse<types.PaymentGLEntry[]>>(`/payments/${id}/gl-entries`);
    return response.data.data;
  }

  async getCreditTargets(paymentId: string): Promise<types.CreditTargets> {
    const response = await this.http.get<types.APIResponse<types.CreditTargets>>(`/payments/${encodeURIComponent(paymentId)}/credit-targets`);
    return response.data.data;
  }

  async applyCredit(paymentId: string, data: types.ApplyCreditRequest): Promise<types.ApplyCreditResult> {
    const response = await this.http.post<types.APIResponse<types.ApplyCreditResult>>(`/payments/${encodeURIComponent(paymentId)}/apply-credit`, data);
    return response.data.data;
  }

  async unapplyCredit(paymentId: string, applicationId: string): Promise<types.UnapplyCreditResult> {
    const response = await this.http.post<types.APIResponse<types.UnapplyCreditResult>>(
      `/payments/${encodeURIComponent(paymentId)}/applications/${encodeURIComponent(applicationId)}/unapply`,
      {}
    );
    return response.data.data;
  }

  async getCustomerCredits(customerId: string): Promise<types.CustomerCredits> {
    const response = await this.http.get<types.APIResponse<types.CustomerCredits>>(`/customers/${encodeURIComponent(customerId)}/credits`);
    return response.data.data;
  }
}
